// 分享链接新增参数schain和stid
// schain 记录分享者ID schain=userId_userId
// stid 记录路由名_分享者ID_分享方式_分享时间戳

import JSBridge from '@lyh/jsbridge'

/**
 * APP使用
 * 传入参数：shareUrl 和 shareType
 * 分享时添加参数并回调新地址
 * shareType 1(app->微信) 2(app->朋友圈) 3(微信->微信) 4(微信->朋友圈) 5(app->小程序) 6(app->动态)
 * @param modUrl
 * @returns {string|*}
 */
function shareUrl_append() {
  JSBridge.JSRegister("shareUrlAppendStid", function (data, responseCallback) {
		var obj = JSON.parse(data)
		let modUrl = ''
    if (obj && obj.param) {
			if (obj.param.shareUrl && obj.param.shareUrl.length) {
				modUrl = rewordH5UrlSchain(obj.param.shareUrl)
				if (obj.param.shareType && obj.param.shareType.length) {
					modUrl = rewordH5UrlStrace(modUrl, obj.param.shareType)
				}
			}
      responseCallback({
        'param': modUrl
      })
    } else {
			responseCallback({
			  'param': ''
			})
		}
  })
}

/**
 * 微信二次转发使用
 * 拼接参数schain和stid
 * 返回拼接好的URL
 * @param shareUrl 分享url 
 * @param shareType @param shareType 3(微信->微信) 4(微信->朋友圈)
 * @returns {string|*}
 */
function setUrlSchainAndStid(shareUrl, shareType) {
  let ssUrl = ''
  if (shareUrl && shareUrl.length > 0) {
    let schainUrl = rewordH5UrlSchain(shareUrl)
    ssUrl = schainUrl
    if (shareType) {
      shareType = shareType + ''
      ssUrl = rewordH5UrlStrace(schainUrl, shareType)
    }
  }
  return ssUrl
}

/**
 * 二次分享时，H5中的wsharep.shareurl可能不是location.href，得从location.href判断schain和stid
 * @returns {string|*}
 */
function rewordH5UrlStrace(shareUrl, shareType) {
  if (shareUrl) {
    let resLink = shareUrl
    let resStid = getShareUrlQuery(resLink, 'stid')
    if (resStid && resStid.length > 0) {
      // 存在，透传
    } else {
      // 不存在，判断location.href上有没有
      let locationUrl = location.href || ''
      let locationStid = getShareUrlQuery(locationUrl, 'stid')
      if (locationStid && locationStid.length > 0) {
        // 存在setShareUrlQuery
        resLink = setShareUrlQuery(resLink, {'stid': locationStid})
      } else {

        // 判断链接中的share_method，是否分享过
        let orginMethod = getShareUrlQuery(resLink, 'share_method')
        if (orginMethod && orginMethod.length > 0) {
          // 存在分享方式，表示非首次分享，不再添加stid(兼容旧版)
        } else {

          // 不存在，重新设置
          resLink = setShareUrlQuery(resLink, {'stid': combineStrace(resLink, shareType)})
        } 
      }
    }
    // H5的shareMethod覆盖
    if (shareType == 3) {
      resLink = setShareUrlQuery(resLink,{share_method:'h5_wechat_session'})
    } else if (shareType == 4) {
      resLink = setShareUrlQuery(resLink,{share_method:'h5_webchat_timeline'})
    }

    return resLink
  } else {
    return ''
  }
}

/**
 * 二次分享时，更新URL中schain数据
 * schain数据格式: userId_userId_userId_
 * @param shareUrl
 * @returns {string|*}
 */
function rewordH5UrlSchain(shareUrl) {
  if (shareUrl && shareUrl.length > 0) {
    let orginSchain = getShareUrlQuery(shareUrl, 'schain')
    let newSchain = ''
    // 如果分享URL存在schain参数，则拼接schain参数
    if (orginSchain && orginSchain.length > 0) {
      newSchain = orginSchain + '_' + getSharePid()
    } else {
      // 不存在，判断location上有没有
      let locationUrl = location.href || ''
      let locationSchain = getShareUrlQuery(locationUrl, 'schain')
      if (locationSchain && locationSchain.length > 0) {
        newSchain = locationSchain + '_' + getSharePid()
      } else {

        // 判断链接中的share_method，是否分享过
        let orginMethod = getShareUrlQuery(shareUrl, 'share_method')
        if (orginMethod && orginMethod.length > 0) {
          // 存在分享方式，表示非首次分享，不再添加schain(兼容旧版)
          return shareUrl
        }

        newSchain = getSharePid()
      }
    }
    const newShareUrl = decodeURI(encodeURI(shareUrl).replace(/%E2%80%8B/g, ''))
    let tempUrl = new URL(newShareUrl)
    tempUrl.searchParams.set('schain', newSchain)
    return tempUrl.toString()
  } else {
    return shareUrl
  }
}

/**
 * 往url中拼接query参数以及其对应的值 (如果是良医汇带#的url,则query会拼接到#前面)
 * @param url 待操作的url
 * @param keyValue 待插入到url中的query键值对
 */
function setShareUrlQuery(url, keyValue) {
  let tempUrl = new URL(url)
  for (let key in keyValue) {
    tempUrl.searchParams.set(key, keyValue[key])
  }
  return tempUrl.toString()
}

/**
 * 根据key，获取url中的value
 * @param currentUrl
 * @param key
 * @returns {string}
 */
function getShareUrlQuery(currentUrl, key) {
  /* start 解决零宽空格导致new URL(url)报错的问题 */
  const newUrl = decodeURI(encodeURI(currentUrl).replace(/%E2%80%8B/g, ''))
  /* end 解决零宽空格导致new URL(url)报错的问题 */
  const url = new URL(newUrl)
  return url.searchParams.get(key)
}

// 组合starce数据
function combineStrace(shareUrl, shareType) {
  // 路由名称
  let pathName = ''
  if (shareUrl) {
    let urlArr = shareUrl.split('#/')
    if (urlArr.length > 1) {
      let pathArr = urlArr[1].split('?')
      if (pathArr.length > 0) {
        let newName = pathArr[0]
        pathName = newName.replace(/\//g, '-')
      }
    }
  }
  // 分享者
  let shareUser = getSharePid()
  // 分享渠道
  let type = shareType || ''
  // 分享时间
  let shareTime = Date.parse(new Date()) / 1000
  return pathName + '_' + shareUser + '_' + type + '_' + shareTime
}

// 缓存里——获取分享者Id
function getSharePid() {
  let pid = ''
	// 匿名ID
	let anonymousID = localStorage.getItem('AnonymousID')
	if (anonymousID && anonymousID.length) {
		pid = anonymousID
	}
	// 已存用户信息
	let userInfo = sessionStorage.getItem('userinfoobjstr')
	if (userInfo && userInfo.length) {
		const userinfoobjstr = JSON.parse(userInfo) || ''    
		if (userinfoobjstr && userinfoobjstr.userid) {
			pid = userinfoobjstr.userid
		}
	}
	// 已存userID
	let userId = sessionStorage.getItem('userId')
	if (userId && userId.length) {
		pid = userId
	}
  return pid
}


(function() {
  window.shareUrl_append = shareUrl_append
  window.setUrlSchainAndStid = setUrlSchainAndStid
})()
